module.exports = __webpack_public_path__ + "img/optometry.766c2978.svg";